import clsx from "clsx";

export default function Landing() {
  return (
    <div className={landingStyle}>
      Howdy, Partner! <br />
      Click a sidebar option to get started.
    </div>
  );
}

const landingStyle = clsx(
  "w-full flex h-screen text-center w-full items-center justify-center uppercase text-xl tracking-wider"
);
